export default function Testimonials() {
  const reviews = [
    {
      stars: 5,
      quote: 'Best barbershop experience ever!',
      review: 'The attention to detail is incredible. My fade was perfect and the vibe in the shop is unmatched. This is where I bring my sons now.',
      name: 'Marcus Johnson',
      location: 'Downtown',
      avatar: 'https://public.readdy.ai/ai/img_res/da55e3a57f70ea37c298838a5eb41fd5.jpg'
    },
    {
      stars: 5,
      quote: 'More than just a haircut',
      review: 'Nappy Rootz is a community hub. The barbers are skilled artists who take pride in their work. I always leave feeling fresh and uplifted.',
      name: 'Jamal Williams',
      location: 'Westside',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20African%20American%20man%20in%20his%20early%20twenties%20with%20clean%20buzz%20cut%20hairstyle%2C%20clean%20shaven%20face%2C%20bright%20friendly%20smile%20showing%20teeth%2C%20wearing%20graphic%20t-shirt%2C%20natural%20lighting%2C%20simple%20solid%20light%20gray%20background&width=100&height=100&seq=testimonial002&orientation=squarish'
    },
    {
      stars: 5,
      quote: 'Finally found my barber!',
      review: 'After years of searching, I found my spot. They understand Black hair and the culture. The hot towel service is next level.',
      name: 'Darius Thompson',
      location: 'Eastside',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20mature%20African%20American%20man%20in%20his%20late%20forties%20with%20salt%20and%20pepper%20hair%2C%20distinguished%20full%20beard%20with%20gray%20streaks%2C%20gentle%20genuine%20smile%2C%20wearing%20collared%20polo%20shirt%2C%20soft%20lighting%2C%20simple%20solid%20warm%20cream%20background&width=100&height=100&seq=testimonial003&orientation=squarish'
    },
    {
      stars: 5,
      quote: 'Exceptional service every time',
      review: 'The consistency is what keeps me coming back. Whether it\'s a quick lineup or a full service, they never disappoint. True professionals.',
      name: 'Kevin Brown',
      location: 'Northside',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20African%20American%20man%20in%20his%20late%20twenties%20with%20stylish%20high%20top%20fade%20haircut%2C%20thin%20mustache%20and%20goatee%2C%20confident%20cool%20expression%2C%20wearing%20denim%20jacket%2C%20dramatic%20lighting%2C%20simple%20solid%20dark%20charcoal%20background&width=100&height=100&seq=testimonial004&orientation=squarish'
    },
    {
      stars: 5,
      quote: 'The only place I trust',
      review: 'Been coming here since they opened. The barbers are family now. They know exactly what I want and always deliver perfection.',
      name: 'Andre Davis',
      location: 'Southside',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20African%20American%20man%20in%20his%20mid%20thirties%20with%20medium%20length%20natural%20locs%20hairstyle%20pulled%20back%2C%20full%20thick%20beard%2C%20warm%20welcoming%20smile%2C%20wearing%20casual%20hoodie%2C%20golden%20hour%20lighting%2C%20simple%20solid%20soft%20tan%20background&width=100&height=100&seq=testimonial005&orientation=squarish'
    },
    {
      stars: 5,
      quote: 'A cut above the rest',
      review: 'The skill level here is unmatched. My beard and hair have never looked better. Plus the atmosphere makes you feel right at home.',
      name: 'Terrell Jackson',
      location: 'Central',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20African%20American%20man%20in%20his%20early%20twenties%20with%20fresh%20taper%20fade%20haircut%20and%20sharp%20edge%20up%2C%20clean%20shaven%20smooth%20face%2C%20big%20bright%20cheerful%20smile%2C%20wearing%20athletic%20jersey%2C%20bright%20natural%20lighting%2C%20simple%20solid%20white%20background&width=100&height=100&seq=testimonial006&orientation=squarish'
    }
  ];

  return (
    <section className="py-24 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
            <p className="text-amber-500 text-sm font-bold tracking-wider">CLIENT LOVE</p>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white leading-tight mb-4">
            WHAT THE<br />COMMUNITY SAYS
          </h2>
          <p className="text-stone-500 text-base">Real reviews from real people</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div key={index} className="bg-neutral-950 border border-neutral-800 p-8 rounded-2xl hover:border-amber-500/30 transition-all">
              <div className="flex gap-1 mb-4">
                {[...Array(review.stars)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                ))}
              </div>
              <h4 className="text-lg font-bold text-white mb-3">{review.quote}</h4>
              <p className="text-stone-400 text-sm leading-relaxed mb-6">{review.review}</p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0 border-2 border-amber-500/30">
                  <img src={review.avatar} alt={review.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="font-bold text-white text-sm">{review.name}</p>
                  <p className="text-stone-500 text-xs">{review.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
